import axios from 'axios';
// const BASE_URL = process.env.REACT_APP_API_URL
// console.log(11111,BASE_URL)
const BASE_URL = process.env.NODE_ENV === 'development' ? '' : "https://admin.northbundforum.com"
// const BASE_URL = process.env.NODE_ENV === 'development' ? '' : "http://northbund.aolu.vip"
// console.log(process.env.NODE_ENV === 'development' ? '' : "admin.northbundforum.com")
const api = {
  post(url, data,) {
    return new Promise((resolve, reject) => {
      const apiUrl = BASE_URL + url
      axios.post(`${apiUrl}`, data,).then(response => {
        if (response.status === 200) {
          const resp = response.data
          // if(resp.code === 0) {
          resolve(response.data)
          // } else {
          //   reject(response)
          // }
        } else {
          reject(response)
        }
      }).catch(error => reject(error));
    })
  },
  get(url, params) {
    const apiUrl = BASE_URL + url
    return new Promise((resolve, reject) => {
      axios.get(`${apiUrl}`, { params }).then(response => {
        if (response.status === 200) {
          const resp = response.data
          // if(resp.code === 0) {
          resolve(response.data)
          // } else {
          //   reject(response)
          // }
        } else {
          reject(response)
        }
      }).catch(error => reject(error));
    });
  }
}

export default api